import { API_URL_BASE, BUILD_NUMBER } from 'Env';

export function profPicUrl(userId: string, size = 100): string {
  return `${API_URL_BASE}/api/v1/prof_pics/${userId}/` +
    `${size}?X-Bios-Build=${BUILD_NUMBER}`;
}
